import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

import { computed } from 'vue';
import TextBlockHandler from '@/shared/content/blocks/helpers/TextBlockHandler.vue';
import { CollageTileLayout } from '@/shared/content/blocks/collage-layouts/collage-layout.store';
import Swiper from '@/shared/Swiper.vue';
import CollageTileHorizontalSliderTile
    from '@/shared/content/blocks/collage-layouts/default-layout-helpers/CollageTileHorizontalSliderTile.vue';
import { SwiperOptions } from 'swiper';
import Breakpoints from '@/core/responsive/breakpoints/Breakpoints.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CollageTileHorizontalSliderLayout',
  props: {
    content: null,
    isReversedLayout: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    content: CollageTileLayout;
    isReversedLayout: boolean;
}



const tileModelData = computed(() => {
    const arrayMobile: any = [];
    const arrayDesktop: any = [];
    let currentPosMobile = -1;
    let currentPosDesktop = -1;

    props.content.tiles.forEach((tile: any, index: number) => {
        if (index % 2 === 0) {
            currentPosMobile++;
        }
        if (index % 4 === 0) {
            currentPosDesktop++;
        }
        Array.isArray(arrayMobile[currentPosMobile]) ? arrayMobile[currentPosMobile].push(tile.model) : arrayMobile[currentPosMobile] = [tile.model];
        Array.isArray(arrayDesktop[currentPosDesktop]) ? arrayDesktop[currentPosDesktop].push(tile.model) : arrayDesktop[currentPosDesktop] = [tile.model];
    });

    return { mobile: arrayMobile, desktop: arrayDesktop };
});

const slidesPerViewMobile = 1;
const swiperOptionsMobile: Partial<SwiperOptions> = {
    spaceBetween: 0,
    centeredSlides: false,
    freeMode: false,
    slidesPerView: slidesPerViewMobile + 0.105,
    slidesPerGroup: slidesPerViewMobile,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
};
const slidesPerViewDesktop = 1;
const swiperOptionsDesktop: Partial<SwiperOptions> = {
    spaceBetween: 0,
    centeredSlides: false,
    freeMode: false,
    slidesPerView: slidesPerViewDesktop + 0.11, // 90% as in old solution
    slidesPerGroup: slidesPerViewDesktop,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
};

const textColorClass = computed(() => {
    return props.content.textColor ? `color: ${props.content.textColor}` : null;
});

return (_ctx: any,_cache: any) => {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!

  return (_openBlock(), _createElementBlock("section", {
    class: "relative",
    style: _normalizeStyle(_unref(textColorClass))
  }, [
    _createVNode(TextBlockHandler, {
      class: "md:w-1/2 text-black mr-auto mx-20 mb-20 md:mx-10 md:mb-15",
      title: __props.content.title,
      heading: __props.content.subheading,
      text: __props.content.text
    }, null, 8, ["title", "heading", "text"]),
    _createVNode(Breakpoints, null, {
      "max-sm": _withCtx(() => [
        _createVNode(Swiper, {
          class: "c-swiper-teaser-overlay",
          options: swiperOptionsMobile
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tileModelData).mobile, (section, blockListIndex) => {
              return (_openBlock(), _createBlock(_component_SwiperSlide, {
                key: blockListIndex,
                class: "grid grid-cols-2 ml-0"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section, (item, itemIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: itemIndex,
                      class: "aspect-ratio-1/1 min-h-200 mr-10"
                    }, [
                      _createVNode(CollageTileHorizontalSliderTile, {
                        data: item,
                        "aspect-ratio": { default: 1 }
                      }, null, 8, ["data"])
                    ]))
                  }), 128))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      "min-md": _withCtx(() => [
        _createVNode(Swiper, {
          class: "c-swiper-teaser-overlay mx-0",
          options: swiperOptionsDesktop
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tileModelData).desktop, (section, blockListIndex) => {
              return (_openBlock(), _createBlock(_component_SwiperSlide, {
                key: blockListIndex,
                class: "grid grid-cols-4 gap-0 ml-0"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section, (item, itemIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: itemIndex,
                      class: "aspect-ratio-1/1 min-h-200 mr-10"
                    }, [
                      _createVNode(CollageTileHorizontalSliderTile, {
                        data: item,
                        "aspect-ratio": { default: 1 }
                      }, null, 8, ["data"])
                    ]))
                  }), 128))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 4))
}
}

})